import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CustomTable from '../../components/Shared/CustomTable'
import PageHeader from '../../components/Shared/PageHeader'

export default function ViewAllowancePage () {
  const location = useLocation()
  const { t } = useTranslation()
  const allowance = location?.state?.allowance || null

  const columns = [
    {
      header: t('name'),
      body: row => `${row.employee?.first_name || ''} ${row.employee?.last_name || ''}`
    },
    { field: 'allowance_type', header: t('allowance_type') },
    { field: 'amount', header: t('amount') },
    { field: 'effective_date', header: t('effective_date') },
    { field: 'description', header: t('description') }
  ]

  if (!allowance) {
    return (
      <div>
        <PageHeader title={t('Allowance Details')} />
        <p className='mt-4'>{t('No_allowance_selected')}</p>
        <div className='mt-4'></div>
      </div>
    )
  }

  const data = [allowance]

  return (
    <div>
      <PageHeader title={t('Allowance Details')} />
      <CustomTable data={data} columns={columns} rows={1} />
    </div>
  )
}
